import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { deleteUrl: String }

  getConfirmationModal() {
    const modalElement = document.querySelector('[data-controller~="confirmation-modal"]')
    if (modalElement) {
      return this.application.getControllerForElementAndIdentifier(modalElement, "confirmation-modal")
    }
    return null
  }

  confirmDelete(event) {
    event.preventDefault()

    const modal = this.getConfirmationModal()
    if (modal) {
      modal.show(
        "Pašalinti porą",
        "Ar tikrai norite pašalinti šią porą ir visus jos nustatymus?",
        () => this.performDelete()
      )
    } else {
      if (confirm("Ar tikrai norite pašalinti šią porą?")) {
        this.performDelete()
      }
    }
  }

  performDelete() {
    fetch(this.deleteUrlValue, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/html'
      },
      redirect: 'manual'
    }).then(() => {
      // Reload just the Turbo Frame instead of full page
      const resultsFrame = document.querySelector('#defaults-results')
      if (resultsFrame && resultsFrame.reload) {
        resultsFrame.reload()
      } else {
        // Fallback if frame reload unavailable
        window.location.reload()
      }
    })
  }
}
